import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/roxana-carmenate-lcsw")({
  beforeLoad: () => {
    throw redirect({ to: "/roxana-carmenate", replace: true });
  },
});
